import React, { useState, useRef } from "react";
import * as styles from "./SlideDownUp.module.scss";
import { CSSTransition } from "react-transition-group";
// import classNames from "classnames";
import PropTypes from "prop-types";

const SlideDownUp = ({ delay = 0, show, openCallback, children }) => {
	let timoutId = 0;
	const nodeRef = useRef(null);
	const [elementHeight, setElementHeight] = useState(0);
	const cssTransitionProps = {
		in: show,
		timeout: {
			enter: delay,
			exit: 1000,
		},
		onEnter: () => {
			window.clearTimeout(timoutId);
			nodeRef.current.style.height = "auto";
			setElementHeight(nodeRef.current.offsetHeight);
			nodeRef.current.style.height = 0;
		},
		onEntered: () => {
			nodeRef.current.style.height = elementHeight + "px";
			nodeRef.current.addEventListener(
				"transitionend",
				(event) => {
					event.currentTarget.style.height = "auto";
					event.currentTarget.classList.add(styles.open);
					if (openCallback) {
						openCallback(event);
					}
				},
				{ once: true },
			);
		},
		onExit: () => {
			nodeRef.current.style.height = nodeRef.current.offsetHeight + "px";
			nodeRef.current.classList.remove(styles.open);
			window.clearTimeout(timoutId);
			timoutId = window.setTimeout(() => {
				nodeRef.current.style.height = 0;
			}, 0);
		},
		classNames: styles,
		enter: true,
		mountOnEnter: true,
		unmountOnExit: true,
		nodeRef,
	};

	return (
		<CSSTransition {...cssTransitionProps}>
			<div ref={nodeRef}>{children}</div>
		</CSSTransition>
	);
};

SlideDownUp.propTypes = {
	show: PropTypes.bool,
	delay: PropTypes.number,
	openCallback: PropTypes.func,
	children: PropTypes.node,
};

export default SlideDownUp;
